import { render } from "./accountListNonmove.vue?vue&type=template&id=5952c1fc&scoped=true"
import script from "./accountListNonmove.vue?vue&type=script&lang=js"
export * from "./accountListNonmove.vue?vue&type=script&lang=js"

import "./accountListNonmove.vue?vue&type=style&index=0&id=5952c1fc&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5952c1fc"]])

export default __exports__